import { observer } from 'mobx-react-lite';
import { Container, Sprite } from '@pixi/react';

import { useStore } from '../../../../../hooks';
import { isMobile } from '../../../../../helpers';
import { getGameImages } from '../../../../helpers';
import { JackPotSceneItemContent } from './jackPotSceneItemContent';

export const JackPotSceneItemWrapper: React.FC<any> = observer(({
  jackpotIcons,
  jackPotSymbols,
  jackPotItemEnum,
  symbolMoveContainerRef,
}) => {
  const { jackpotStore } = useStore()
  const { jackPotData, winCard, setWinCard } = jackpotStore;
  const { symbolsContainerBg } = getGameImages();  
  
  return (
    <Container {...({ name: 'JackPotSymbolsSectionContainer' } as any)}>
      <Sprite
        anchor={0.5}
        x={isMobile() ? 270 : 717}
        y={isMobile() ? 463 : 442}
        texture={symbolsContainerBg}
      />
      {jackPotSymbols.map((itemIndex: number, index: number) => {        
        const jackpotSceneItemInfo = jackPotData.find((el) => el.index === itemIndex);
        return (
          <JackPotSceneItemContent
            key={itemIndex}
            winCard={winCard}
            itemIndex={itemIndex}
            setWinCard={setWinCard}
            jackpotIcons={jackpotIcons}
            jackPotItemEnum={jackPotItemEnum}
            x={(isMobile() ? 126 : 569) + Math.floor(index % 3) * 143}
            y={(isMobile() ? 379 : 224) + Math.floor(index / 3) * 145}
            jackpotSceneItemInfo={jackpotSceneItemInfo}
            symbolMoveContainerRef={symbolMoveContainerRef}
          />
        );
      })}
    </Container>
  );
});
